import { createSlice } from "@reduxjs/toolkit";
import { 
    getUserData,
    getMainAccount,
    getgoldsoldvalue,
    getGoldWeigth,
    getOutstanding,
    getShipment,
    getShipmentOrder,
    getVendorPending,
    getTemp,
    getManager

} from './thunk'; 

export const initialState = {
    orders: [],
    sellers: [],
    productList: [],
    productGrid: [],
    reviews: [],
    errors: {},

    users: [],
    account : { data : 0  },
    goldSold :{  data : 0 },
    goldWeigth :{  data : 0 },
    goldOutstanding:{ data:0 },
    shipment:[] ,
    shipmentOrder:[],
    vendorPending:[],
    temp:[],
    Manager:[]

};

const EcommerceSlice = createSlice({
    name: 'Ecommerce',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        //users
        builder.addCase(getUserData.fulfilled, (state: any, action: any) => {
            state.users = action.payload ;
        });
        builder.addCase(getMainAccount.fulfilled, (state: any, action: any) => {
            state.account = action.payload ;
        });
        builder.addCase(getgoldsoldvalue.fulfilled,(state:any ,action:any)=>{
            state.goldSold = action.payload ;
        })
        builder.addCase(getGoldWeigth.fulfilled,(state:any ,action:any)=>{
            state.goldWeigth = action.payload ;
        })
        builder.addCase(getOutstanding.fulfilled,(state:any , action:any)=>{
            state.goldOutstanding = action.payload ;
        })
        builder.addCase(getShipment.fulfilled,(state:any , action :any)=>{
            state.shipment=action.payload
        })
        builder.addCase(getShipmentOrder.fulfilled,(state:any , action :any)=>{
            state.shipmentOrder=action.payload
        })
         builder.addCase(getVendorPending.fulfilled,(state:any , action :any)=>{
            state.vendorPending=action.payload
        })
        builder.addCase(getTemp.fulfilled,(state:any , action :any)=>{
            state.temp=action.payload
        })
        builder.addCase(getManager.fulfilled,(state:any , action :any)=>{
            state.Manager=action.payload
        })









 
    }
});

export default EcommerceSlice.reducer;